import TravelRequestsResource from "./travelRequests.resource";

const travelRequestsModule = angular
  .module("app.resources.travelRequests", [])
  .service("TravelRequest", TravelRequestsResource);

export default travelRequestsModule;



// WEBPACK FOOTER //
// ./src/resources/travelRequests/travelRequests.module.js